<!-- 🌫️ Backdrop -->
<div class="backdrop" *ngIf="isOpen" (click)="onBackdropClick()"></div>
<div *ngIf="canUsePanel">
  <!-- Hover zone (unchanged) -->
  <div class="hover-zone" (click)="togglePanel($event)" [style.cursor]="!isPinned ? 'pointer' : 'default'">
    <div class="hover-tooltip" *ngIf="newNotify">
      {{ tooltipMessage }}
    </div>
  </div>
  <!-- 🧩 Slide Panel -->
  <div class="slide-panel" (mouseenter)="onHoverEnter()" (mouseleave)="onHoverLeave()" [class.peek]="hoverPreview" (click)="togglePanel($event)" [class.left]="panelside === 'left'"
    [class.right]="panelside === 'right'" [style.width]="panelWidth" [@slideInOut]="animationState">
      <!-- 🔔 Badge: Always active if newNotify -->
      <!-- <div *ngIf="newNotify" class="notification-badge">
        {{ badgeCount > 99 ? '99+' : badgeCount }}
      </div> -->
      <button
        *ngIf="allowPinning"
        [style.transform]="'rotate(' + (isPinned ? 0 : 45) + 'deg)'"
        class="btn-icon fs-6 fas pin-toggle"
        mdbRipple
        (click)="$event.stopPropagation(); isPinned ? unpinPanel() : pinPanel()">

        <i class="fas fa-1x fa-thumbtack"></i>
      </button>
    <lms-quote-feed  class="content-zone m-2" [quotes]="quotes" (click)="$event.stopPropagation()"></lms-quote-feed>
  </div>
</div>
